import React from "react";
import { DataHelper } from "../Helpers/DataHelper";
import { PreviewMeasurement } from "../Models/PreviewMeasurement";
import ChartD3 from "./ChartD3";
import { StudyModel } from "../Models/StudyModel";
import { LoadingWidget } from "./LoadingWidget";
import DragBar from "./DragBar";
import TTFMTileHolder from "./TTFMTileHolder";
import { ZoomButtons } from "./ZoomButtons";
import { UploadDataHelper, viewMode } from "../Helpers/SharedClasses";
import html2canvas from "html2canvas";
import { Graft } from "../Models/Trigger/TriggerClasses";
import { ReferenceValuesModel } from "../Models/ReferenceValuesModel";


export class LargeTTFMCurve extends React.Component<
    {
        subType: string,
        studySelected: StudyModel,
        dataReceiver: DataHelper, 
        measurementPreview: PreviewMeasurement,
        procedureId: string,
        width: number, 
        height: number,
        usefilling: boolean
        color: string, 
        color1: string, 
        color2: string, 
        color3: string, 
        includeScrubber: boolean,
        yAxisVisible: boolean,
        xAxisVisible: boolean,
        parentGroup: string,
        xAxisMax: number,
        meanCutOff1: number, 
        meanCutOff2: number, 
        saveScrollerPosition?: (posInSeconds: number, saveSuccess: (success: boolean)=> void, lastMean: number, lastPI: number, lastACI: number, displayRangeMin: number, displayRangeMax: number) => void
        scrubberAdjusted?: (newPositionInDatapoints: number, axisSizeInDatapoints: number) => void
    },
    {
        tileMode: string,
        axisSize: number,
        cursorPosition: number, 
        dataLoaded: boolean,
        errorMessage: string,
        phasicity: string,
        originalYAxisMin: number,
        originalYAxisMax: number,
        yRange:number,
        meanFlow: number,
        meanACI: number,
        pulsatilityIndex: number,
        diastolicFilling: number,
        flowViewMode: viewMode,
        positionJustSaved: boolean, 
        positionSaving: boolean,
        indexConfig: ReferenceValuesModel
    }
> {

 
    currentData: any = null;
    holderDiv: React.RefObject<HTMLDivElement>;
    ttfmChartd3: React.RefObject<ChartD3>;
    tilelimits: any;
    ttfmTileHolder: React.RefObject<TTFMTileHolder>;
    constructor(props: any) {
        super(props);
        this.holderDiv = React.createRef();
        this.ttfmChartd3 = React.createRef();
        this.ttfmTileHolder = React.createRef();
        let uploadHelper: UploadDataHelper = new UploadDataHelper();
        this.state = {
            tileMode: "Gauges", 
            axisSize: props.xAxisMax,
            cursorPosition: props.xAxisMax,
            dataLoaded: false,
            errorMessage: "",
            phasicity: "", 
            originalYAxisMax: 0,
            originalYAxisMin: 0,
            yRange:0,
            meanFlow: Math.abs(this.props.measurementPreview.mean as number)  *1000,
            meanACI: (this.props.measurementPreview.aCIMean as number),
            pulsatilityIndex: (this.props.measurementPreview.pI as number),
            diastolicFilling: (this.props.measurementPreview.dF as number),
            flowViewMode: this.props.studySelected.defaultView  ? this.props.studySelected.defaultView as viewMode : viewMode.Intui,
            positionJustSaved: false, 
            positionSaving: false,
            indexConfig: uploadHelper.getDefaultIndexConfiguration(this.props.studySelected)

        }

        this.tilelimits  ={
            ACI: {
           worstRange:{
                          min: 0,
                          max: 20
                      },
                          badRange:{
                          min: 20,
                          max: 50
                      },
                          goodRange:{
                          min: 50,
                          max: 102
                      } 
            },
           
              backFlow: {
                goodRange: {
                  min: -2,
                  max: 3
              },
              badRange: {
                  min: 3,
                  max: 5
              },
              worstRange: {
                  min: 5,
                  max: 50
              }
            },
            meanFlow: {
              worstRange:{
                min: 0,
                max: props.meanCutOff1
            },
                badRange:{
                min: props.meanCutOff1,
                max: props.meanCutOff2
            },
                goodRange:{
                min: props.meanCutOff2,
                max: props.meanCutOff2 > 1000 ? props.meanCutOff2+100 : 1000
            }},
            pulsalityIndex:
            { goodRange: {
              min: -3,
              max: 3
          },
      badRange: {
              min: 3,
              max: 5
          },
      worstRange: {
              min: 5,
              max: 100
          }}, 
            diastolicFilling: 
            {
              goodRange: {
                min: 60,
                max: 110
            },
      badRange: {
                min: 30,
                max: 60
            },
      worstRange: {
                min: 0,
                max: 30
            }
            },
            MAP: { goodRange:{
              min: 60,
              max: 200
          },
              badRange:{
              min: 0,
              max: 60
          },
              worstRange:{
              min: 0,
              max: 0
          }}
        }
    }
    reservedKeys = ["Phase", "PhaseFull", "ECG", "PI", "ACI", "x", "DFOLD", "DF"];
    calculateYAxis = (dataToRenderAll: any, zoomFactor = 1, offsetY = 0, reset: boolean = false): number[] => 
    {
        let yAxisMin = 0;
        let yAxisMax = 0;
        let { originalYAxisMin, originalYAxisMax } = this.state;


        if(reset || (originalYAxisMax===0 && originalYAxisMin===0)){

            
         if (this.props.measurementPreview.displayRangeMax !== 0)
        {
            originalYAxisMax = this.props.measurementPreview.displayRangeMax as number * 1000;
            originalYAxisMin = this.props.measurementPreview.displayRangeMin as number * 1000;
            yAxisMin = originalYAxisMin;
            yAxisMax = originalYAxisMax;
            this.setState({
                originalYAxisMin: originalYAxisMin,
                originalYAxisMax: originalYAxisMax,
                yRange: originalYAxisMax-originalYAxisMin,
            });
        }
         else   if (dataToRenderAll)
            {
         
                for (let dataProp in dataToRenderAll) {
                    if (this.reservedKeys.indexOf(dataProp) === -1)
                    {
                    const dataValues = dataToRenderAll[dataProp];
                    if (dataValues && dataValues.length > 0) {
                        for (let index = 0; index < dataValues.length; index++) {
                            const element = dataValues[index];
                         
                            if (yAxisMin > element)
                            {
                                yAxisMin = element;
                            }
                            if (yAxisMax < element)
                            {
                                yAxisMax = element;
                            } 
                        }
                    }
                    }
                }
            }
            this.setState({
                originalYAxisMin: yAxisMin,
                originalYAxisMax: yAxisMax,
                yRange: yAxisMax-yAxisMin,
            });
        }else{
            const range = originalYAxisMax - originalYAxisMin;
            const center = (originalYAxisMax + originalYAxisMin) / 2;
            yAxisMin = Math.trunc(center + (offsetY*range) - (range / 2) / zoomFactor);
            yAxisMax = Math.trunc(center + (offsetY*range) + (range / 2) / zoomFactor);
            this.setState({
                originalYAxisMin: yAxisMin,
                originalYAxisMax: yAxisMax,
                yRange: yAxisMax-yAxisMin,
            });
        }
        return [yAxisMin, yAxisMax];
    }

    addDataPoints = (dataToRenderAll: any, compareMode = false, scrubberPos = 0, zoomFactor = 1, offsetY = 0, reset = false) =>
    {
        let colorPalette = [this.props.color1, this.props.color3, "var(--Raven)", "var(--GreenApple)", "var(--Crocodile)", "var(--BananaClan)", "var(--Bluejay)", "var(--FireEngineRed)"]
        let MainKey = "BLUE";
        
        let ttfmChartd3: ChartD3 = (this.ttfmChartd3.current as ChartD3);
        if (!ttfmChartd3)
            return;

        let xAxisSize = this.props.xAxisMax;
        const [yAxisMin, yAxisMax] =  this.calculateYAxis(dataToRenderAll, zoomFactor, offsetY, reset);

      ttfmChartd3.resetDrawingArea(null, null, yAxisMin, yAxisMax, xAxisSize, 0, 0 );
      let seriesIndex = 0;
      for (let dataProp in dataToRenderAll) {
          if (this.reservedKeys.indexOf(dataProp) === -1)
          {
          const dataValues = dataToRenderAll[dataProp];
          if (dataValues && dataValues.length > 0) {
              if (dataProp === MainKey)
              {

                let color1 = this.props.color1;
                let color2 = this.props.color2;
                if (this.state.flowViewMode === viewMode.Legacy)
                    {
                        color1 = "var(--LegacyFill2)";
                        color2 = "var(--LegacyFill1)";
                    }

            if ((dataToRenderAll["PhaseFull"] && dataToRenderAll["PhaseFull"].length > 0) || (dataToRenderAll["Phase"] && dataToRenderAll["Phase"].length > 0)){ //&& dataToRenderAll["Phase"] &&dataToRenderAll["Phase"].length > 0) {

             
            
                if (dataToRenderAll["PhaseFull"] && dataToRenderAll["PhaseFull"].length > 0 )
                {
                    //First draw a filled line with no change in phase and mark the items added with their x value.
                    ttfmChartd3.addAreaData(dataToRenderAll[dataProp], color1, "TTFM", dataToRenderAll["x"], compareMode, scrubberPos);
                    ttfmChartd3.setAreaColor(dataToRenderAll["PhaseFull"], color2, color2);
                }
else if (dataToRenderAll["Phase"].length > 0 )
{

                var phaseMarker = -1;
                var lastDrawn = 0;
                for (let index = 0; index < dataToRenderAll["Phase"].length; index++) {
                    const element = dataToRenderAll["Phase"][index];
                    if (element !== phaseMarker) {
                        if (phaseMarker === -1) {
                            phaseMarker = element;
                        } else {
                            ttfmChartd3.addAreaData(dataToRenderAll[dataProp].slice(lastDrawn, index), ((phaseMarker === 1)
                                ? color1
                                : color2), "TTFM", dataToRenderAll["x"].slice(lastDrawn, index), compareMode, scrubberPos);
                            phaseMarker = element;
                          //  datapointsaddedblue = datapointsaddedblue - lastDrawn + index;
                            lastDrawn = index;
                        }
                    }
    
                }
                if (lastDrawn < dataToRenderAll[dataProp].length) {
                    let lastPhaseCutoff = 135;
                    if (dataToRenderAll[dataProp].length - lastDrawn > lastPhaseCutoff)
                    {
                        //If it wasn't drawn all the way to the end the draw the last bit.
                        ttfmChartd3.addAreaData(dataToRenderAll[dataProp].slice(lastDrawn, dataToRenderAll[dataProp].length-lastPhaseCutoff), ((phaseMarker === 1)
                            ? color1
                            : color2), "TTFM", dataToRenderAll["x"].slice(lastDrawn, dataToRenderAll[dataProp].length-lastPhaseCutoff), compareMode, scrubberPos);

                         //add the last 100 switched in color? This must be something to do with the way the MiraQ software renders the Filling.
                        lastDrawn = dataToRenderAll[dataProp].length-lastPhaseCutoff;
                    }
                   
                    ttfmChartd3.addAreaData(dataToRenderAll[dataProp].slice(lastDrawn, dataToRenderAll[dataProp].length), ((phaseMarker === 1)
                        ? color2
                        : color1), "TTFM", dataToRenderAll["x"].slice(lastDrawn, dataToRenderAll[dataProp].length), compareMode, scrubberPos);

                   // datapointsaddedblue = datapointsaddedblue - lastDrawn + dataToRenderBlue.length;
                }

            }else
            {
                ttfmChartd3.addAreaData(dataToRenderAll[dataProp], color1, "TTFM", dataToRenderAll["x"], compareMode, scrubberPos);
            }
                
            }else
            {
                let colorToUse = this.props.color1;
                if (colorToUse=== "var(--SassySalmon)")
                {
                    if (this.state.flowViewMode === viewMode.Legacy)
                    {
                        colorToUse = "var(--ActiveDodgerBlue)"
                    }else
                    {
                        colorToUse = "var(--Lacustral)";
                    }
                }
                //Override the first color to something darker when there is no filling.
                ttfmChartd3.addLineData(dataToRenderAll[dataProp], colorToUse, "TTFM", dataToRenderAll["x"], compareMode, scrubberPos);
            }
        }else{

            let colorToUse = colorPalette[seriesIndex];
            if (dataProp === "RED")
            {
                colorToUse = colorPalette[1];
                if (this.state.flowViewMode === viewMode.Legacy)
                {
                    colorToUse = "var(--BernRed)"
                }
            }
             
            
            ttfmChartd3.addLineData(dataToRenderAll[dataProp],colorToUse, dataProp, dataToRenderAll["x"], compareMode, scrubberPos);

        }

          }
          seriesIndex++;
        }
        
   
      }
    }

    analyzeWindow = (dataFlow: number[], dataACI: number[], dataPI: number[], dataMean: number[], dataDF: number[], position: number, windowSize: number = 1000)=> {
        if (!dataFlow || dataFlow.length === 0) return { meanFlow: 0, pi: 0 };
        
        const start = Math.max(0, position - windowSize);
        const end = position;
        const flowValues = dataFlow.slice(start, end);
        if (!dataACI) dataACI = [];
        const ACIValues = !dataACI ? [] : dataACI.slice(start, end);
        
        if (flowValues.length === 0) return { meanFlow: 0, pi: 0 };
       
        
        const peakSystolic = Math.max(...flowValues);
        const endDiastolic = Math.min(...flowValues);
        let meanFlowSubset = flowValues.reduce((acc, val) => acc + val, 0) / flowValues.length;
        let meanACISubset = ACIValues.reduce((acc, val) => acc + val, 0) / ACIValues.length;
        let pi = meanFlowSubset !== 0 ? (peakSystolic - endDiastolic) / Math.abs(meanFlowSubset) : 0;
        let dfOut: number = 0;
        position = Math.round(position);
        meanFlowSubset = dataMean[position >= dataMean.length ? dataMean.length-1 : position];
        meanACISubset = dataACI[position >= dataACI.length ? dataACI.length-1 : position];
        pi = dataPI[position >= dataPI.length ? dataPI.length-1 : position]/1000;
        if (dataDF)
        {
            dfOut = dataDF[position >= dataDF.length ? dataDF.length-1 : position];
        }else
            dfOut = this.props.measurementPreview.dF as number;
        return { meanFlowSubset, pi, meanACISubset, dfOut };
    }
    
    findOptimalPosition = () => {
        if (!this.currentData?.BLUE) return 0;
        
        let bestScore = -Infinity;
        let bestPosition = 0;
        
        for (let pos = this.props.xAxisMax; pos < this.currentData.BLUE.length; pos += 100) {
            const { meanFlowSubset, pi, meanACISubset, dfOut } = this.analyzeWindow(this.currentData.BLUE, this.currentData.ACI, this.currentData.PI, this.currentData.RED, this.currentData.DF, pos);
            // Score favors high meanFlow and low PI
            const score = this.props.dataReceiver.calculateFlowScore(meanFlowSubset as any, pi, meanACISubset as number, dfOut as number);
            if (score > bestScore) {
                bestScore = score;
                bestPosition = pos;
            }
        }
        
        return bestPosition;
    }

    convertSecondsToDataPoints = (valueInSeconds: number) =>
        {
            let recordedLength = this.props.measurementPreview.recordedLength;
            if (!recordedLength)
                recordedLength = 60.0;
            let sweepLength = this.props.measurementPreview.sweepLength;
            if (!sweepLength)
                sweepLength = 5.0;
            // let sweepPosition = this.props.measurementPreview.sweepPosition;
            // if (!sweepPosition)
            //     sweepPosition = 0.0;
    
            let ratioSecondsToDataPoints = (this.state.axisSize/recordedLength);
    
            let posInDataPointsRelative = (recordedLength - valueInSeconds) * ratioSecondsToDataPoints;
            return posInDataPointsRelative;
            
        }

        
    convertDataPointsToSeconds = (valueInDataPoints: number) =>
        {
            let recordedLength = this.props.measurementPreview.recordedLength;
            if (!recordedLength)
                recordedLength = 60.0;
            let sweepLength = this.props.measurementPreview.sweepLength;
            if (!sweepLength)
                sweepLength = 5.0;
            // let sweepPosition = this.props.measurementPreview.sweepPosition;
            // if (!sweepPosition)
            //     sweepPosition = 0.0;
    
            let ratioDataPointsToSeconds = (recordedLength/this.state.axisSize);
            let posInSecondsRelative = (this.state.axisSize - valueInDataPoints) * ratioDataPointsToSeconds;
            return posInSecondsRelative;
            
        }


    adjustScrubberInSeconds = (valueInSeconds: number) =>
    {
        // let recordedLength = this.props.measurementPreview.recordedLength;
        // if (!recordedLength)
        //     recordedLength = 60.0;
        // let sweepLength = this.props.measurementPreview.sweepLength;
        // if (!sweepLength)
        //     sweepLength = 5.0;
        // // let sweepPosition = this.props.measurementPreview.sweepPosition;
        // // if (!sweepPosition)
        // //     sweepPosition = 0.0;

        // let ratioSecondsToDataPoints = (this.state.axisSize/recordedLength);

        // let posInSecondsRelative = (recordedLength - valueInSeconds) * ratioSecondsToDataPoints;

        // let scrubberPosInDataPoints = this.state.axisSize;
        let posInDataPointsRelative = this.convertSecondsToDataPoints(valueInSeconds);
        this.adjustScrubber(posInDataPointsRelative);
    }

    adjustScrubber = (value: number) =>
    {
        if (!this.currentData?.BLUE || !this.currentData?.PI ) return;

        const { meanFlowSubset, pi:pulsatilityIndex, meanACISubset, dfOut } = this.analyzeWindow(this.currentData.BLUE, this.currentData.ACI, this.currentData.PI, this.currentData.RED, this.currentData.DF, value);

        
        this.setState({ 
            cursorPosition: value,
            meanFlow: meanFlowSubset as any,
            meanACI: meanACISubset as any,
            
            pulsatilityIndex: pulsatilityIndex,
            diastolicFilling: dfOut as number,
            positionJustSaved: false,
            positionSaving: false
        }, ()=> {
        this.addDataPoints(this.currentData, true, value); 
        if (this.props.scrubberAdjusted)
            this.props.scrubberAdjusted(value-this.props.xAxisMax, this.props.xAxisMax);
    
    })
        
    }
    
    formatXAxisLabels = (value: number) =>
    {
        return "";
        //return value/200 + "s";
    }

     static defaultProps ={
        subType: "Flow",
        width: 720,
        height: 560,
        usefilling: true,
        includeScrubber: false,
        color: "black",
        color1: "var(--SassySalmon)",
        color2: "var(--WaterySea)",
        color3: "var(--Lacustral)",
        yAxisVisible: true,
        xAxisVisible: true,
        parentGroup: "",
        xAxisMax: 1000,
        scrubberAdjusted: ()=>{},
     }

     onVisible = (element: Element, callback: (e:Element) => void) => {
        new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if(entry.intersectionRatio > 0) {
              callback(element);
              observer.disconnect();
            }
          });
        }).observe(element);
    }
    
    onViewModeSwitch = () =>
    {
        this.setState({
            flowViewMode: (this.state.flowViewMode === viewMode.Intui ? viewMode.Legacy : viewMode.Intui)
        }, ()=>{
            this.adjustScrubber(this.state.axisSize);
        });
    }

    refreshData = (callback: () => void)=>
    {
        if (this.props.measurementPreview.id && !this.currentData)
        {
            // this.setState({
            //     dataLoaded: false
            // });
            if (this.props.measurementPreview.indicesColorGraded && this.props.measurementPreview.indexConfigurationId)
            {
                this.props.dataReceiver.GetIndexConfig(this.props.studySelected.id as string,  this.props.measurementPreview.indexConfigurationId, (indexConfig: ReferenceValuesModel)=>
                {
                    if (indexConfig)
                    {
                        this.setState({
                            indexConfig: indexConfig
                        });
                    }
                });
            }
            this.props.dataReceiver.CallService("MiscData", "GetFlowData", {}, { studyId: this.props.studySelected.id, measurementId: this.props.measurementPreview.id, procedureId: this.props.procedureId, measurementType: this.props.subType, tokenId: this.props.dataReceiver.miscToken},  (measurementDataRaw: string)=>{
            this.currentData = {};
            if (measurementDataRaw)
            {
            this.currentData = JSON.parse(measurementDataRaw);
                 this.addDataPoints( this.currentData, true, this.currentData["x"].length);
            this.setState({
                axisSize: this.currentData["x"].length,
                cursorPosition: this.currentData["x"].length      ,
                dataLoaded: true  
             }, callback);
            }else
            {
                this.setState({
                    errorMessage: "No flow measurement data found.",
                    dataLoaded: true
                 });
            }
        }, (errorVal: any) =>
        {
            this.setState({
                errorMessage: "Unable to load measurement",
                dataLoaded: true
             });
            console.log("Error loading thumbnail data: " + errorVal.message)
        }, "GET", false);


        // this.props.dataReceiver.CallService("MiscData", "GetFlowPhasicity", {}, { studyId: this.props.studySelected.id, measurementId: this.props.measurementPreview.id, procedureId: this.props.procedureId, measurementType: this.props.subType, tokenId: this.props.dataReceiver.miscToken},  (measurementDataRaw: string)=>{

        //     this.setState({
        //         phasicity: measurementDataRaw
        //      });
           
        // }, (errorVal: any) =>
        // {
        //     // this.setState({
        //     //     errorMessage: "Unable to load measurement",
        //     //     dataLoaded: true
        //     //  });
        //     console.log("Error loading thumbnail phasicity: " + errorVal.message)
        // }, "GET", false);

        }
    }



    handleZoomOffsetChange = (zoomFactor: number, offset:number) => {
        this.setState({
            positionSaving: false, positionJustSaved: false
        }, ()=>{
            this.addDataPoints(this.currentData, true, this.state.cursorPosition, zoomFactor, offset);
        });
          
    }





    componentDidMount(): void {
        if (this.holderDiv.current)
        this.onVisible(this.holderDiv.current, (e: Element) =>
        {
            this.refreshData(()=>{

            

                this.adjustScrubberInSeconds(this.props.measurementPreview.sweepPosition as number);//1000 is the default position of one full "screen" of data.

            });
        });
        

      
    }
    
    onsaveImage = ()=>
    {
            //"flowcurvepreview" + this.props.measurementPreview.id)
            let divIn = (document.getElementById("flowcurvepreview" + this.props.measurementPreview.id) as HTMLElement);
            // let divIn = (document.getElementById("LARGEFLOWDIAG"+this.props.parentGroup+this.props.measurementPreview.id) as HTMLElement);
            html2canvas(divIn).then((canvas) => {


                // Convert the canvas to a data URL
                var imgData = canvas.toDataURL('image/png');
                
                // Create a link element
                var link = document.createElement('a');
                link.href = imgData;
                link.download = 'screenshot.png';
                
                // Trigger a click event on the link to download the image
                link.click();
               
            });
        
        
    }

    lockScroller = ()=>
    {
        if(this.props.saveScrollerPosition)
        {
            this.setState({
                positionSaving: true
            });
            let displayRangeMax = this.state.originalYAxisMax;
            let displayRangeMin = this.state.originalYAxisMin;
            // if (this.state.originalYAxisMin > this.state.originalYAxisMax)
            // {
            //     displayRangeMax = this.state.originalYAxisMin;
            //     displayRangeMin = this.state.originalYAxisMax;
            // }
            displayRangeMax = displayRangeMax /1000;
            displayRangeMin = displayRangeMin /1000;
            this.props.saveScrollerPosition(this.convertDataPointsToSeconds(this.state.cursorPosition), (success: boolean)=>
            {
                //Save successful!
                this.setState({
                    positionJustSaved: success,
                    positionSaving: false
                });
            },
            this.state.meanFlow, this.state.pulsatilityIndex, this.state.meanACI , displayRangeMin, displayRangeMax
            );
        }
    }

    checkIfScrollerIsSaved = () =>
    {
        let isSaved = this.convertDataPointsToSeconds(this.state.cursorPosition) === this.props.measurementPreview.sweepPosition;
        // if (this.state.originalYAxisMin !== this.props.measurementPreview.displayRangeMin as number * 1000 && this.state.originalYAxisMin !== this.props.measurementPreview.displayRangeMax as number * 1000)
        // {
        //     isSaved = false;
        // }
        if (this.state.originalYAxisMax !== this.props.measurementPreview.displayRangeMax as number * 1000 && this.state.originalYAxisMin !== this.props.measurementPreview.displayRangeMin as number * 1000)
        {
            isSaved = false;
        }
        return isSaved;

    }

    render() {
        let dateParsed = new Date( this.props.measurementPreview.recordDate as any) as Date;
        let locationText = (this.props.measurementPreview != null && this.props.measurementPreview.anatomicalLocations != null && this.props.measurementPreview.anatomicalLocations.length > 0) ? this.props.measurementPreview.anatomicalLocations?.join('-') : "";
        if (!locationText)
        {
            if (this.props.measurementPreview != null && this.props.measurementPreview.intuiGraft != null)
            {
                let anatomicalLocations: string[] = [];
                Graft.getGraftName(this.props.measurementPreview.intuiGraft, anatomicalLocations);
                locationText = anatomicalLocations?.join('-');
            }
        }
        return (
            <>
             <ZoomButtons flowViewMode={this.state.flowViewMode} onsaveImage={this.onsaveImage} onViewModeSwitch={this.onViewModeSwitch} onZoomOffsetChange={this.handleZoomOffsetChange} onFlipCalled={()=>{
                          this.setState({ originalYAxisMax: this.state.originalYAxisMin, originalYAxisMin: this.state.originalYAxisMax, positionSaving: false, positionJustSaved: false }, 
                            () => {
                            
                                this.addDataPoints(this.currentData, true, this.state.cursorPosition);
                                
                        });
                  }} 
                  onResetCurve={()=>
                  {
                    let value = this.convertSecondsToDataPoints(this.props.measurementPreview.sweepPosition as number);
                    this.setState({ 
                        cursorPosition: value,
                        positionJustSaved: false,
                        positionSaving: false
                    }, ()=>
                    {
                        this.addDataPoints(this.currentData, true, this.state.cursorPosition, 1, 0, true);
                    });
                     
                  }
                  }
                  onFindOptimalPosition={()=>{
                    const optimalPos = this.findOptimalPosition();
                    this.adjustScrubber(optimalPos);
                  }}
                    
                 zoomIncrement={1.5} offSetIncrement={0.1} minZoom={0.1} maxZoom={20}></ZoomButtons>
            <div id={"flowcurvepreview" + this.props.measurementPreview.id}  className={"flowcurvepreview-container" + this.state.flowViewMode + (this.state.originalYAxisMin > this.state.originalYAxisMax  ? " isFlipped" : "")} >
            <div id={"flowcurverender" + this.props.measurementPreview.id} >
               <div className="thumbnail-container" ref={this.holderDiv}>
               {
                    this.state.errorMessage ?
                    <div className="thumbnailError">{this.state.errorMessage}</div>
                    :
                    <>           
                <LoadingWidget visible={!this.state.dataLoaded} zIndexLayer={0}></LoadingWidget>
                {this.props.subType === "Flow" 
                ?<TTFMTileHolder studySelected={this.props.studySelected} ref={this.ttfmTileHolder} indexConfig={this.state.indexConfig} ttfmCurves={1} overrideName={this.props.procedureId} context="TTFM" MAP={this.props.measurementPreview.mAPMean ? this.props.measurementPreview.mAPMean as number : "--"} ACI={Math.abs(this.state.meanACI)} mapStale={false} usefilling={true} BeatsPerMinute={this.props.measurementPreview.bPMMean as number ? this.props.measurementPreview.bPMMean as number : "--"} tileMode={this.state.flowViewMode === viewMode.Legacy ?  "Tiles" : this.state.tileMode} tilesExpanded={true} tileClicked={()=>{ 
                    this.setState({
                    tileMode: this.state.tileMode === "Tiles"  ? "Gauges" : "Tiles"
                }, ()=>{
                    (this.ttfmTileHolder.current as TTFMTileHolder).performResize();
                });
                }} tileValueChanged={()=>{}} PulsalityIndex={this.state.pulsatilityIndex as number} MeanFlow={Math.abs(this.state.meanFlow as number)}  BackFlow={this.props.measurementPreview.insuf ? this.props.measurementPreview.insuf as number : "--"} DiastolicFilling={this.state.diastolicFilling ? this.state.diastolicFilling as number : "--"} ></TTFMTileHolder>
            :<></>}
         
            <div className="TTFMScopeSettings">
           
                    <div className="ttfmChart">
                  <ChartD3
                    ref={this.ttfmChartd3}
                    id={"LARGEFLOWDIAG"+this.props.parentGroup+this.props.measurementPreview.id}
                    autoscroll={true}
                    width={this.props.width}
                    height={this.props.height}
                    yaxismin={0}
                    yaxismax={100}
                    xaxisposition={0}
                    xaxismax={this.props.xAxisMax}
                    yAxisVisible={this.props.yAxisVisible}
                    xAxisVisible={this.props.xAxisVisible}
                    color="var(--WaterySea)"
                    colorOutline={this.state.flowViewMode === viewMode.Legacy ? "var(--LegacyOutline)" : "var(--dolphin)"}
                    yAxisLabel={this.props.subType === "Flow" ? "ml/mm" : (this.props.subType === "PWDopplers" ? "cm/s" : "")}
                    margintop={5}
                    marginleft={26}
                    marginright={5}
                    marginbottom={50}
                    xAxisMinimal={true}
                    xAxisLabelsFormat={(val: any)=>{
                        return"";
                    }}
                    xaxisLabel={this.props.subType === "PWDopplers" ? "7s" : "5s"}
                    ></ChartD3></div>
                    </div>
                       
                    
                    
                     {/* <div><span>Phasicity: </span><span>{this.state.phasicity}</span></div> */}
                     <div className="bottomCurveInfo">
                        <div className="probeChannelWrap">
                            <div className="probeChannelButton">
                                <div className="channelButtonLabel">{this.props.measurementPreview.channelDescription}</div>
                                <div className="channelButtonSubLabel">{this.props.measurementPreview.probeSize}mm</div>
                            </div>
                            <div className="probeChannelDetails"><span> Probe Serial Number: </span><span>{this.props.measurementPreview.probeSerialNumber}</span></div> 
                        </div>
                        <div className="anatomicalLabel">
                            <div>{locationText ? locationText : "Location Undefined"}</div>
                        </div>
                        <div className="measurementdatetime">
                            {dateParsed.toLocaleString()}
                        </div>
                     </div>
                     

                    <div className="sliderWrapper TTFMSlider">
                        <DragBar name={"compareTTFMSlider"+this.props.measurementPreview.flowId} valueWidth={this.props.xAxisMax}   xAxisLabelsFormat={this.formatXAxisLabels} value={ this.state.cursorPosition} max={this.state.axisSize} min={0} onChange={this.adjustScrubber}  height={80} width={this.props.width + 6}></DragBar> 
                        <div className="lockScrollerWrapper">
                            <button className={"lockScrollerButton primaryButton " + (this.state.positionSaving ? " savingLock" : (this.state.positionJustSaved || this.checkIfScrollerIsSaved() ? " locked" : " unlocked"))} onClick={this.lockScroller}>
                                <span className="saveBTNtext ButtonIsSaved">Saved layout</span>
                                <span className="saveBTNtext ButtonIsNotSaved">Save</span>
                                {this.state.positionJustSaved || this.checkIfScrollerIsSaved() ? <>
                                <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M24 22H32V14C32 11.7909 30.2091 10 28 10C25.7909 10 24 11.7909 24 14V22ZM40 22C44.4183 22 48 25.5817 48 30V46C48 50.4183 44.4183 54 40 54H16C11.5817 54 8 50.4183 8 46V30C8 25.5817 11.5817 22 16 22V14C16 7.37258 21.3726 2 28 2C34.6274 2 40 7.37258 40 14V22Z" fill="black"/>
                                </svg>
                                </> : <>
                                <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.2475 22.0349C11.1821 22.4142 8 25.8355 8 30V46C8 50.4183 11.5817 54 16 54H40C44.4183 54 48 50.4183 48 46V30C48 25.5817 44.4183 22 40 22H24.465L20.7065 15.4901C19.602 13.577 20.2575 11.1306 22.1706 10.026C24.0838 8.92146 26.5302 9.57696 27.6347 11.4901L34.5629 7.49013C31.2492 1.75062 23.9101 -0.215881 18.1706 3.09783C12.4311 6.41154 10.4646 13.7506 13.7783 19.4901L15.2475 22.0349Z" fill="black"/>
                                </svg>
                                </>}
                                
                                <span className="lockButtonHover">Lock & Save current layout</span>
                            </button>
                        </div>
                    </div>
                       
                     </>
                }
                 </div>

                </div>
                      
                </div>
            </>
        );
    }
}
